import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PlusSquareTwoToneSvg from "@ant-design/icons-svg/es/asn/PlusSquareTwoTone";
import AntdIcon from '../components/AntdIcon';
var PlusSquareTwoTone = function PlusSquareTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: PlusSquareTwoToneSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  PlusSquareTwoTone.displayName = 'PlusSquareTwoTone';
}
export default /*#__PURE__*/React.forwardRef(PlusSquareTwoTone);